var _radialGradient, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19930",
    cx: 63.6,
    cy: 1992.9,
    r: 56.96,
    gradientTransform: "translate(0 -1930)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fde030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#f7c02b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4a223"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.6 118.8c-27.9 0-58-17.5-58-55.9S35.7 7 63.6 7c15.5 0 29.8 5.1 40.4 14.4c11.5 10.2 17.6 24.6 17.6 41.5s-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5z",
    fill: "url(#IconifyId17ecdb2904d178eab19930)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.49 29.67c5.33 8.6 8.11 18.84 8.11 30.23c0 16.9-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5c-18.06 0-37-7.35-48.18-22.94c10.76 17.66 31 25.94 50.18 25.94c15.4 0 29.8-5.2 40.4-14.5c11.5-10.2 17.6-24.5 17.6-41.4c0-12.74-3.47-24.06-10.11-33.23z",
    fill: "#eb8f00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64 87.15c10.82 0 17.83 7.92 19.65 11.57c.7 1.41.74 2.58.14 3.13c-.63.41-1.45.41-2.08 0c-.31-.15-.62-.32-.9-.52a28.849 28.849 0 0 0-33.61 0c-.28.2-.58.37-.9.52c-.63.42-1.45.42-2.08 0c-.6-.55-.56-1.72.14-3.13c1.81-3.64 8.82-11.57 19.64-11.57z",
    fill: "#422b0d"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#422b0d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.39 39.77c-2.2.39-2.31 3.59.09 3.7c5.3.08 10.42-1.88 14.32-5.47a17.24 17.24 0 0 0 3.71-4.49c.58-.83.38-1.97-.44-2.56s-1.97-.38-2.56.44l-.1.1c-3.93 4.39-9.22 7.3-15.02 8.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.12 31.52l-.1-.1a1.841 1.841 0 0 0-2.56-.45a1.83 1.83 0 0 0-.44 2.56c.98 1.69 2.24 3.2 3.73 4.47c3.9 3.59 9.02 5.54 14.32 5.45c2.4-.11 2.29-3.31.08-3.7c-5.8-.97-11.09-3.87-15.03-8.23z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19931",
    cx: 20.59,
    cy: -404.695,
    r: 33.4,
    gradientTransform: "matrix(1 0 0 -1.54 0 -560.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#29b6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1e88e5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.52 107c-8.46 0-15-8.21-15-15.24c0-4.94 2.21-10.67 5.34-18.61c.39-1.17.91-2.35 1.43-3.65c1.49-3.72 2.8-7.75 4.8-11.24a3.516 3.516 0 0 1 6.14 0c1.86 3.43 3.14 7.14 5.07 11.47c5.47 12.24 7 17.19 7 22.13c.19 6.97-6.45 15.14-14.78 15.14z",
    fill: "url(#IconifyId17ecdb2904d178eab19931)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.67 97.65c-1.91 3-6.25 2.4-6.25-2.51c0-3.14.64-19.26 3.34-17c4.38 3.67 5.63 15.33 2.91 19.51z",
    fill: "#81d4fa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.67 54.94c-4.19 0-8 3.54-8 9.42s3.81 9.41 8 9.41c4.19 0 8-3.54 8-9.41s-3.81-9.42-8-9.42z",
    fill: "#422b0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.28 58.87a2.874 2.874 0 0 0-3.82 1.34c-.53 1.11-.29 2.44.6 3.3c1.42.68 3.13.08 3.82-1.34c.53-1.11.29-2.44-.6-3.3z",
    fill: "#896024"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83 54.94c-4.19 0-8 3.54-8 9.42s3.81 9.41 8 9.41c4.19 0 8-3.54 8-9.41s-3.79-9.42-8-9.42z",
    fill: "#422b0d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.63 58.87a2.874 2.874 0 0 0-3.82 1.34c-.53 1.11-.29 2.44.6 3.3c1.42.68 3.13.08 3.82-1.34c.53-1.11.29-2.44-.6-3.3z",
    fill: "#896024"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/fail_icon.3842312434ca86570078ebff9a4958aa.svg";
export { ForwardRef as ReactComponent };